"use strict";

var uiMoney = require('ui-money');
var _require = require('accounting'),
  formatMoney = _require.formatMoney;

/**
 * Copied from https://github.tlcinternal.com/UITools/ui-handlebars-helpers/blob/master/src/helpers/currencyFormat.js
 * Format number or string with given operation and options.  If the string has
 * a currency name, e.g. "USD 123.00", this is used to determine the default
 * symbol (e.g. $) per https://github.tlcinternal.com/UITools/ui-money
 *
 * Takes the following options:
 * precision, symbol, currency, format
 *
 * @return {String} formatted String that represents currency.
 */
module.exports.currencyFormat = function (num, options) {
  var precision = parseInt(options.precision, 10);
  if (isNaN(precision)) {
    precision = 2;
  }
  var currency = options.currency || options.symbol;
  var formatOverride = options.format;
  var roundFn = options.roundFn;
  if (formatOverride && formatOverride.indexOf('%v') !== -1) {
    // for backwards compatibility with accounting.js format strings used previously
    formatOverride = formatOverride.replace('%s', '¤').replace('%v', '#');
  }
  return new uiMoney(num, currency).format(precision, formatOverride, roundFn);
};

/**
 * Copied from https://github.tlcinternal.com/raw/UITools/ui-handlebars-helpers/master/src/helpers/percentageFormat.js?token=AAAELt8G24hSq6SE8TmbAAIMSS6TWUCAks5bTuC_wA%3D%3D
 * Format number with given operation and options.
 *
 * Defaults:
 * {{percentageFormat xxxx precision='2' format='%v%s'}}
 *
 * {{percentageFormat 0.123 }} = 12.30%
 * {{percentageFormat 0.123 format='%v %s'}} = 12.30 %
 * {{percentageFormat 0.123 precision='0'}} = 12%
 * {{percentageFormat 0.123 precision='0'}} = 13%
 * {{percentageFormat 2.43 precision='2' isPercentage='true'}} = 2.43%
 * {{percentageFormat '' emptySymbol = '--'}} = --
 * {{percentageFormat null emptySymbol = '--' }} = --
 * {{percentageFormat 'dd' }} = dd
 *
 * Beware:
 * {{percentageFormat 12.3 format='%s %v'}} = % 12.30
 *
 * @return {String} formatted String that represents percentage.
 */
module.exports.percentageFormat = function (num, options) {
  var precision = options.precision || 2;
  var format = options.format || '%v%s';
  var emptySymbol = options.emptySymbol || num;
  var isPercentage = options.isPercentage || 'false';
  var symbol = '%';
  if (typeof num !== 'number') {
    num = parseFloat(num);
    if (isNaN(num)) {
      return emptySymbol;
    }
  }
  if (isPercentage === 'false') {
    num = num * 100;
  }
  return formatMoney(num, {
    symbol: symbol,
    precision: precision,
    format: format
  });
};
module.exports.getTitles = function (originalPlan) {
  var titles = {};
  if (originalPlan.productType === 'IF') {
    titles.paymentTitle = 'Sample equal monthly payment';
    titles.periodTitle = 'Promotional period';
    titles.aprTitle = 'APR during promotional period';
  } else if (originalPlan.productType === 'PRP') {
    titles.paymentTitle = 'Monthly payment';
    titles.periodTitle = 'Promotional period';
    titles.aprTitle = 'APR during promotional period';
  } else {
    titles.paymentTitle = 'Monthly payment';
    titles.periodTitle = 'Number of payments';
    titles.aprTitle = 'APR';
  }
  return titles;
};
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');